import { api_config } from "../../../api-commons";

interface ApiDashboardElementResource {
    resource_id : number, 
    dashboard_element_id : number
}

class DasboardElementResourceService {
      async add(params :ApiDashboardElementResource ): Promise<ApiDashboardElementResource> {
        const response = await api_config.post("/dashboard-element_resource/", params) 
        return response.data;
        }

      async delete(params : ApiDashboardElementResource): Promise<ApiDashboardElementResource> {
        const response = await api_config.delete(`/dashboard-element_resource/dashboard-element/${params.dashboard_element_id}/resource/${params.resource_id}`) 
        return response.data;
        }
}

const dashboardElementResourceService = new DasboardElementResourceService();
export default dashboardElementResourceService